module.exports = __webpack_public_path__ + "img/ff43589411a81cad8465fd7603f38ae5.png";